export default __webpack_public_path__ + "static/media/Beep.a4eff7f5.mp3";